export const mapClientPostalCode = (postalCode?: string): string | null => {
  if (!postalCode) return null;

  // postal code matches regex for Canadian postal codes without the space, we add it
  const postalCodeRegex = /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/;
  if (postalCodeRegex.test(postalCode)) {
    return postalCode.slice(0, 3) + ' ' + postalCode.slice(3);
  }

  // if postal code does not match the regex, we return it as is.
  // It's either a correct format or a non-canadian postal code.
  return postalCode;
};
